import { render, staticRenderFns } from "./ArtificialPaperHead.vue?vue&type=template&id=413fc030&scoped=true"
import script from "./ArtificialPaperHead.vue?vue&type=script&lang=js"
export * from "./ArtificialPaperHead.vue?vue&type=script&lang=js"
import style0 from "./ArtificialPaperHead.vue?vue&type=style&index=0&id=413fc030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413fc030",
  null
  
)

export default component.exports